// 启动费
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let contractInfo = get(state, 'currentShopBaseDetail', {})
  return {
    title: i18n.gettext('启动费'),
    content: [
      {
        title: i18n.gettext('金额(円)'),
        label: contractInfo.startupCost / 100
      },
      {
        title: i18n.gettext('扣费次数'),
        label: contractInfo.startupCostNum
      }
    ]
  }
}
